import { css } from '@compiled/react';
import React from 'react';
import { FallbackProps } from 'react-error-boundary';

const styles = css({ color: 'red' });
const { REACT_APP_IS_ERROR_SHOWN = false } = process.env;

const Fallback: React.FC<FallbackProps> = ({ error }) => {
  return REACT_APP_IS_ERROR_SHOWN ? (
    <div role="alert">
      <p>{'Something went wrong:'}</p>
      <pre css={styles}>{error.message}</pre>
    </div>
  ) : (
    <div></div>
  );
};

export default Fallback;
